import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { EMPTY, Observable, catchError, switchMap } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    public authService: AuthService,
    private oauthService: OAuthService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Ignore Third party requests

    // const ignorelist = ['openweathermap.org', 'authentication/token'];
    // if (ignorelist.some(substr => request.url.includes(substr))) {
    //     return next.handle(request);
    // }
    // const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // if (this.authService.isTokenExpired()) {
    //     currentUser.expires_at = null;
    //     console.log('JWT expired: ' + currentUser.token);
    //     console.log('Refreshing new JWT...');
    //     localStorage.setItem('currentUser', JSON.stringify(currentUser));
    //     this.authService.refreshToken().subscribe(data => {
    //         if (data) {
    //             currentUser.token = data.access_token;
    //             currentUser.refresh_token = data.refresh_token;
    //             currentUser.expires_at = data.expires_at;
    //             console.log('new JWT: ' + data.access_token);
    //             localStorage.setItem('currentUser', JSON.stringify(currentUser));
    //             return this.intercept(request, next);
    //         }
    //     });
    // }
    // // add authorization header with jwt token if available

    // if (currentUser && currentUser.token) {
    //     console.log('JwtInterceptor: ' + request.url);
    //     console.log('JwtInterceptor: ' + currentUser.token);
    //     request = request.clone({
    //         setHeaders: {
    //             Authorization: `Bearer ${currentUser.token}`
    //         }
    //     });
    // }

    // console.log('request.url: ' + request.url);
    let urlparams=request.urlWithParams;

    const updatedHeaders = request.headers.set('user-key', 'dae8fdadac6810f986b392dba096449b');


    // Clone the request with updated headers
    request = request.clone({ headers: updatedHeaders });
    const accessToken = (localStorage.getItem("access_token"));

    const idToken = (localStorage.getItem("id_token"));
    const ignorelist = ['config.json'];
    if (ignorelist.some((substr) => request.url.includes(substr))) {
      return EMPTY;
    }
    // Do not append azure token for Third party requests
    const ignoreHeaderlist = ['openweathermap.org'];
    if (ignoreHeaderlist.some((substr) => request.url.includes(substr))) {
      return next.handle(request);
    }
    request = request.clone({
      setHeaders: {
          authorization1: `Bearer ${accessToken}`,
          authorization2: `Bearer ${idToken}`
      }
    });

    // console.log('TokenIntercepter called...' + this.adalService.userInfo.token);
    return next.handle(request)
     .pipe(
       //retry(1),
       catchError((error: HttpErrorResponse) => {
        if(error.status==403){
          return this.authService.getRefreshtokenStorage().pipe(
            switchMap(() => {
              // Retry the original request with the new token
              const newAccessToken = localStorage.getItem('access_token');
              const newIdToken = localStorage.getItem('id_token');
              if (newAccessToken && newIdToken) {
                request = request.clone({
                  setHeaders: {
                    authorization1: `Bearer ${newAccessToken}`,
                    authorization2: `Bearer ${newIdToken}`
                  }
                });
              }
              return next.handle(request);
            })
          );

        }
         let errorMessage = '';
         if (error.error instanceof ErrorEvent) {
           // client-side error
           errorMessage = `Error: ${error.error.message}`;
         } else {
           // server-side error
           errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
           if(error.status===403){
            // Utils.alertWithMesssge("You are not authorized to access..!", "error");
            // this.auth.redirectToDaimler('login');
           }
         }       
        //  return throwError(errorMessage);
       })
     );
    
  }
}
